import router from "@/router";
import isFunction from "lodash/isFunction";
import isObject from "lodash/isObject";
import isEmpty from "lodash/isEmpty";
import store from "@/store";
import Vue from "vue";

export function getModuleRoute(onclick) {
  try {
    const onclickSplit = onclick.split("|");
    switch (onclickSplit[0]) {
      case "tvOpen":
        if (onclickSplit[1] === "all") {
          return {
            name: "tvall",
            query: {
              onclickVal: onclickSplit[2],
            },
          };
        } else if (onclickSplit[1] === "group") {
          return {
            name: "tvgroup",
            query: {
              onclickVal: onclickSplit[2],
            },
          };
        }
        break;
      case "openWeather":
        return {
          name: "weather",
          params: {
            index: 0,
          },
        };
      case "webradioOpen":
        return {
          name: "webradio",
        };
      case "SleepTimerOpen":
        return {
          name: "sleeptimer",
        };
      case "wakeUpOpen":
        return {
          name: "wakeUp",
        };
      case "streamingDevices":
        return {
          name: "streamingdevices",
          params: {
            type: onclickSplit[1],
          },
        };
      case "billPreviewOpen":
        return {
          name: "billpreview",
        };
      case "openFlightInfo":
        return {
          name: "flightinfo",
        };
      case "languageSettingsOpen":
        return {
          name: "language",
        };
      case "openShop":
        return {
          name: "shop",
          params: {
            id: onclickSplit[1],
          },
        };
      case "OpenSkinEPG":
        return {
          name: "epg",
        };
      case "changeSource":
        store.dispatch("device/setSource", {
          source: onclickSplit[1],
          port: onclickSplit[2],
        });
        return {};
      case "openWebApp":
        store.dispatch("device/startApp", { name: onclickSplit[1] });
        return {};
      case "openScreenMirroring":
        store.dispatch("device/startApp", {
          name: "screenmirroring",
        });
        return {};
      case "tvMessagesOpen":
        return {
          name: "tvMessage",
        };
      case "billPreviewOpen":
        return {
          name: "billpreview",
        };
      case "openWebPage":
        return {
          name: "openWebPage",
          params: {
            link: onclickSplit[1],
          },
        };
      case "openTel":
        return {
          name: "openTel",
          params: {
            tel: onclickSplit[1],
          },
        };
      case "openEmail":
        return {
          name: "openEmail",
          params: {
            mailto: onclickSplit[1],
          },
        };
      case "openSearch":
        return {
          name: "search",
        };
      case "tacShopOpen":
        return {
          name: "tacShop",
        };
      default:
        if (
          isFunction(router.getMatchedComponents(onclick)[0]) ||
          isObject(router.getMatchedComponents(onclick)[0]) ||
          (router.getMatchedComponents(onclick).name &&
            router.getMatchedComponents(onclick).name.length > 0)
        ) {
          return onclick;
        }

        return {};
    }
  } catch (e) {
    Vue.logger.error("getModuleRoute", e.message);
    return {};
  }
}

export function getContentpageRoute(contentpage) {
  try {
    var id = /\d+/.exec(contentpage); // cut off "Custom_"
    if (!isEmpty(id)) {
      return {
        name: "contentpage",
        params: {
          cpId: id[0],
        },
      };
    } else {
      return {};
    }
  } catch (e) {
    return {};
  }
}

export function getRoute({ item = {}, mode }) {
  if (item.isPage) {
    let contentpageRoute = getContentpageRoute(item.onclick);
    return router.getMatchedComponents(contentpageRoute).length > 0
      ? contentpageRoute
      : "";
  } else {
    const { onclick, oneapp_onclick } = item;
    if ((mode === "walkin" || mode === "walkin-only") && !isEmpty(onclick)) {
      let moduleRoute = getModuleRoute(onclick);
      return router.getMatchedComponents(moduleRoute).length > 0
        ? moduleRoute
        : "";
    } else if (!isEmpty(oneapp_onclick)) {
      let moduleRoute = getModuleRoute(oneapp_onclick);
      return router.getMatchedComponents(moduleRoute).length > 0
        ? moduleRoute
        : "";
    }

    return "";
  }
}

export function getRouteIcon(item = {}, mode) {
  const { onclick, oneapp_onclick } = item;
  if ((mode === "walkin" || mode === "walkin-only") && !isEmpty(onclick)) {
    return (
      router.resolve(getModuleRoute(onclick)).route.meta.icon ||
      "mdi-library-books"
    );
  } else if (!isEmpty(oneapp_onclick)) {
    return (
      router.resolve(getModuleRoute(oneapp_onclick)).route.meta.icon ||
      "mdi-library-books"
    );
  }

  return "";
}
